import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Row, Table, Button, Divider, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { formatMoney } from '../../../lib/util';



const eval_cols = () => [
    // {
    //     title: "Eval Name",
    //     dataIndex: "name",
    //     key: 'name'
    // },
    // {
    //     title: "Version",
    //     dataIndex: 'version',
    //     key: 'version'
    // },
    {
        title: "Variable ID",
        dataIndex: 'id',
        key: 'id'
    },
]
class EvalVariableView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_visibility: false,
            form_data: {},
            edit_id: null
        };
        this.list_evals = RESTExecutor.list().config({
            label: 'eval_variables',
        }).connect(props.domains.settings);


        console.log("constructed")
    };


    render() {

        let list_evals_res = this.list_evals.response();
        let list_evals_data = list_evals_res.result || {};
 

        let rowsMeta=list_evals_res.meta||{};
        let rowsData = list_evals_data.rows || [];

        let filteredData=JSON.parse(JSON.stringify(rowsData));
        if(this.state.query){
            filteredData=filteredData.filter(({ name="",id="",description="" }) => {
                name = name.toLowerCase();
                id=id.toLowerCase();
                description=description.toLowerCase();
                return name.includes(this.state.query.toLowerCase())
                ||id.includes(this.state.query.toLowerCase())
                ||description.includes(this.state.query.toLowerCase())
                ;
            });
        }

        return (
            <div>
                <Table
                scroll={{x:true}}
                loading={list_evals_res.fetching}
                    columns={eval_cols({
                    })}
                    pagination={{
                        showTotal:(total,range)=>`${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                    dataSource={filteredData}
                    className='main-table'                    size='small'
                    // pagination={{
                    //     simple: true,
                    //     onChange: (current, size) => {
                    //         this.list_evals.config({
                    //             params: {
                    //                 per_page: size,
                    //                 page: current
                    //             }
                    //         }).execute();
                    //     },
                    //     defaultCurrent: 1,
                    //     current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                    //     // defaultPageSize: 20,
                    //     pageSize: (rowsMeta && rowsMeta.requested_count),

                    //     total: (rowsMeta && rowsMeta.total_count),
                    //     showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                    // }}

                    title={() =><div> <Row type='flex' justify='space-between' style={{
                        alignItems: 'center'
                    }}><Title
                        type='secondary'
                        level={3}

                        style={{
                            margin: 0
                        }}>Variable List</Title>
                       
                    </Row><br></br>
                    <Row type='flex'
                    justify='space-between'
                    style={{
                    alignItems: 'center',
                    flexWrap: 'nowrap'
                }}>
                        <Input.Search
                            placeholder="Search For"
                            style={{
                        }}autoFocus
                            value={this.state.query}
                            onChange={(e) => {
                                this.setState({query:e.target.value})
                            }}
                           /> {this.state.query && this.state.query.length > 0 && <Button
                            style={{
                            marginLeft: 4
                        }}
                            type='danger'
                            shape="circle"
                            icon="close-circle"
                            onClick={() => {
                            this.setState({query:null})
                        }}/>}
                    </Row></div>}
                    rowKey={(record) => record.id}
                />
            </div>
        )
    }

    componentDidMount() {
        this.list_evals.execute()
    }
}

export default withDomains(EvalVariableView, "settings");
